import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ChevronDown, Instagram, Facebook, Linkedin, Phone } from 'lucide-react';
import { locations } from '../data/mock';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_casaloco-flavors/artifacts/mrxtkbpi_Casa%20Loco%20Logo%20%285%29.png";

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [locationsOpen, setLocationsOpen] = useState(false);

  return (
    <>
      <style>
        {`
          * { box-sizing: border-box; }
          .casa-header {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            z-index: 9999;
            background-color: #F4EFE6;
            border-bottom: 4px solid #1A1918;
          }
          .casa-header-inner {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 72px;
            padding-left: 12px;
            padding-right: 12px;
            max-width: 100%;
          }
          .casa-logo { height: 64px; width: auto; }
          .casa-desktop-nav {
            display: none;
            align-items: center;
            gap: 28px;
          }
          .casa-desktop-nav a,
          .casa-desktop-nav button {
            font-family: 'Space Mono', monospace;
            letter-spacing: 0.15em;
            font-size: 13px;
            font-weight: 700;
            color: #1A1918;
            text-decoration: none;
            background: none;
            border: none;
            cursor: pointer;
            display: flex;
            align-items: center;
            text-transform: uppercase;
            padding: 4px 0;
            border-bottom: 2px solid transparent;
            transition: border-color 0.2s;
          }
          .casa-desktop-nav a:hover,
          .casa-desktop-nav button:hover {
            border-bottom-color: #EE2535;
          }
          .casa-mobile-btn {
            display: flex !important;
            align-items: center;
            justify-content: center;
            width: 48px;
            height: 48px;
            background-color: #EE2535;
            border: 3px solid #1A1918;
            cursor: pointer;
            color: white;
            -webkit-tap-highlight-color: transparent;
            box-shadow: 3px 3px 0 #1A1918;
          }
          .casa-mobile-menu {
            position: fixed;
            top: 76px;
            left: 0;
            right: 0;
            bottom: 0;
            width: 100%;
            background-color: #1A1918;
            border-top: 4px solid #EE2535;
            padding: 0;
            z-index: 9998;
            overflow-y: auto;
            display: flex;
            flex-direction: column;
          }
          .casa-mobile-menu-links {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding: 24px 24px 16px;
            gap: 4px;
          }
          .casa-mobile-menu a.casa-nav-link {
            display: block;
            padding: 14px 20px;
            font-family: 'Rye', cursive;
            letter-spacing: 0.1em;
            font-size: 20px;
            color: white;
            text-decoration: none;
            background: transparent;
            text-transform: uppercase;
            border-left: 4px solid transparent;
            transition: border-color 0.2s, color 0.2s;
          }
          .casa-mobile-menu a.casa-nav-link:hover,
          .casa-mobile-menu a.casa-nav-link:active {
            border-left-color: #F7B638;
            color: #F7B638;
          }
          .casa-mobile-menu-footer {
            padding: 20px 24px;
            border-top: 2px solid #333;
            text-align: center;
          }
          .casa-mobile-menu-footer p {
            font-family: 'Space Mono', monospace;
            font-size: 11px;
            color: #666;
            margin: 0;
          }
          .casa-mobile-menu-footer .casa-social-row {
            display: flex;
            justify-content: center;
            gap: 12px;
            margin-bottom: 12px;
          }
          .casa-mobile-menu-footer .casa-social-row a {
            width: 36px;
            height: 36px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            border: 1px solid #444;
            text-decoration: none;
            transition: border-color 0.2s, background 0.2s;
          }
          .casa-mobile-menu-footer .casa-social-row a:hover {
            border-color: #F7B638;
            background: rgba(247,182,56,0.1);
          }
          .casa-dropdown {
            position: absolute;
            top: 100%;
            left: 0;
            margin-top: 8px;
            background: #F4EFE6;
            border: 2px solid #1A1918;
            box-shadow: 4px 4px 0 #1A1918;
            padding: 8px 0;
            min-width: 180px;
            z-index: 100;
          }
          .casa-dropdown a {
            display: block;
            padding: 10px 20px;
            color: #1A1918;
            text-decoration: none;
            font-family: 'Space Mono', monospace;
            font-size: 13px;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 0.1em;
          }
          .casa-dropdown a:hover {
            background-color: #F7B638;
          }
          @media (min-width: 1024px) {
            .casa-desktop-nav { display: flex; }
            .casa-mobile-btn { display: none !important; }
            .casa-logo { height: 56px; }
            .casa-header-inner {
              max-width: 1280px;
              margin: 0 auto;
              padding-left: 16px;
              padding-right: 16px;
            }
          }
        `}
      </style>

      <header className="casa-header" data-testid="main-header">
        <div className="casa-header-inner">
          <Link to="/" data-testid="header-logo-link">
            <img src={LOGO_URL} alt="Casa Loco" className="casa-logo" />
          </Link>

          <nav className="casa-desktop-nav" data-testid="desktop-nav">
            <Link to="/about" data-testid="nav-about">About Us</Link>
            <Link to="/food-menu" data-testid="nav-food-menu">Food Menu</Link>
            <Link to="/express" data-testid="nav-express">Casa Loco Express</Link>
            <div style={{ position: 'relative' }}>
              <button onClick={() => setLocationsOpen(!locationsOpen)} data-testid="nav-locations-btn">
                Locations
                <ChevronDown style={{ marginLeft: '4px', width: '16px', height: '16px', transform: locationsOpen ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }} />
              </button>
              {locationsOpen && (
                <div className="casa-dropdown">
                  {locations.map((loc) => (
                    <Link key={loc.id} to={`/location/${loc.name.toLowerCase()}`} onClick={() => setLocationsOpen(false)} data-testid={`nav-location-${loc.name.toLowerCase()}`}>
                      {loc.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          </nav>

          <button className="casa-mobile-btn" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Menu" type="button" data-testid="mobile-menu-btn">
            {mobileMenuOpen ? <X size={28} strokeWidth={3} /> : <Menu size={28} strokeWidth={3} />}
          </button>
        </div>
      </header>

      {mobileMenuOpen && (
        <div className="casa-mobile-menu" data-testid="mobile-menu">
          <div className="casa-mobile-menu-links">
            <Link className="casa-nav-link" to="/about" onClick={() => setMobileMenuOpen(false)} data-testid="mobile-nav-about">About Us</Link>
            <Link className="casa-nav-link" to="/food-menu" onClick={() => setMobileMenuOpen(false)} data-testid="mobile-nav-food-menu">Food Menu</Link>
            <Link className="casa-nav-link" to="/express" onClick={() => setMobileMenuOpen(false)} data-testid="mobile-nav-express">Casa Loco Express</Link>
            <Link className="casa-nav-link" to={`/location/${locations[0]?.name.toLowerCase()}`} onClick={() => setMobileMenuOpen(false)} data-testid="mobile-nav-location">
              Location
            </Link>
          </div>
          <div className="casa-mobile-menu-footer">
            <div className="casa-social-row">
              <a href="https://www.instagram.com/casalocoindia/" target="_blank" rel="noopener noreferrer"><Instagram size={16} /></a>
              <a href="https://www.facebook.com/casalocoindia/" target="_blank" rel="noopener noreferrer"><Facebook size={16} /></a>
              <a href="https://www.linkedin.com/company/casalocoindia" target="_blank" rel="noopener noreferrer"><Linkedin size={16} /></a>
              <a href="tel:+918790896655"><Phone size={16} /></a>
            </div>
            <p style={{ color: '#F7B638', fontFamily: "'Rye', cursive", fontSize: '13px', marginBottom: '4px' }}>NOW OPEN!</p>
            <p>2nd Floor, Radisson Hitec City, Gachibowli</p>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;